export class AttributeSearchConditionView {
    public code: string;
    public name: string;
    public domainCode: string;
    public mapping: string;
    public categoryCode: string;
    public groupCode: string;
    public typeCode: string;
    public statusCode: string;
}